import { useOnlineOfflineManagementSubscription } from '@components/profile-dropdown/hooks/use-user-online-management';
import { useCallFailedErrorSusbcription } from './use-call-failed-subscription';
import { useCallerIdVerificationSubscription } from './use-callerid-subscription';
import { useChannelCounterSubscription } from './use-channel-counter-subscription';
import { useContactImportSubscription } from './use-contact-import-subscription';
import { useConversationSubscription } from './use-conversation-subscriptions/use-conversation-subscription';
import { useMemberConversationSubscription } from './use-member-conversation-subscription';
import { useRoomNotesSubscription } from './use-room-notes-subscription';
import { useScheduleStatusSubscription } from './use-schedule-status-subscription';
import { useNotificationSubscriptions } from './use-notification-subscriptions';
import { useWalletSubscription } from '@shared/hooks/use-wallet-details-subscription';
import { useWorkspaceRateLimitSubscription } from '@/types/generated/graphql';
import { useExportContactsSubscription } from '@modules/contacts/hooks/use-export-contacts-subscription';
import { useExportBulkImportJobRowsSubscription } from '@modules/bulk-messaging/bulk-sms-message/hooks/use-export-bulk-import-job-rows-subscription';
import { useTranscriptionStatusSubscription } from '@modules/conversations/hooks/use-transcription-status-subscription';
import {
  useLiveConferenceCountSubscriptionHandler,
  useliveConferenceSubscriptionHandler,
} from './use-live-conference-subscription';
import { useWorkspaceCountSubscription } from '@shared/layouts/app-layout/components/sidebar/hooks/use-workspace-count-subscription';
import { useKYCVerification } from './use-kyc-verification';
import { useScheduledMessageSubscription } from '@modules/conversations/features/message-schedule/hooks/use-message-schedule-subscription';
import { useQueuedCallsSubscription } from '@modules/phone/features/queued-calls/hooks/use-queued-calls-subscription';
import { useWorkspaceMemberNotificationCounterHandler } from './use-workspace-member-notification-counter-subscription';
import { usePaymentOrderNotifications } from './use-payment-order-created-subscription';

export function SubscriptionsManager() {
  useChannelCounterSubscription();
  useConversationSubscription();
  useNotificationSubscriptions();
  useCallerIdVerificationSubscription();
  useContactImportSubscription();
  useCallFailedErrorSusbcription();
  useMemberConversationSubscription();
  useRoomNotesSubscription();
  useScheduleStatusSubscription();
  useOnlineOfflineManagementSubscription();
  useWalletSubscription();
  useScheduledMessageSubscription();
  useWorkspaceRateLimitSubscription();
  useExportContactsSubscription();
  useExportBulkImportJobRowsSubscription();
  useTranscriptionStatusSubscription();
  useliveConferenceSubscriptionHandler();
  useLiveConferenceCountSubscriptionHandler();
  useWorkspaceCountSubscription();
  useKYCVerification();
  useWorkspaceMemberNotificationCounterHandler();
  usePaymentOrderNotifications();
  useQueuedCallsSubscription();

  return null;
}
